/**
 * @file modules/my_cash_paypal_form.js
 * @description Client-side validation for the PayPal modal form.
 *              Uses fragno-input's native error/error-message attributes.
 */

import { dispatchTrack } from "../analytics/shop-analytics-track.js";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function initPaypalForm() {
  const form = document.querySelector(".my-cash-paypal-form__form");
  if (!form) return;

  form.addEventListener("submit", (e) => {
    clearAllErrors(form);

    let valid = true;
    valid = validateEmail(form) && valid;
    valid = validateConfirmation(form) && valid;

    if (!valid) {
      e.preventDefault();
      const firstError = form.querySelector("fragno-input[error]");
      if (firstError) {
        firstError.scrollIntoView({ behavior: "smooth", block: "center" });
      }
      return;
    }

    syncHiddenInputs(form);
    dispatchTrack(form, "my_cash_paypal_email_submit", {
      source: "My Cash",
      label: "Update PayPal Email",
    });
  });
}

function getFragnoInput(form, validateAttr) {
  const field = form.querySelector(`[data-validate="${validateAttr}"]`);
  const fragnoInput = field?.querySelector("fragno-input");
  const nativeInput =
    fragnoInput?.querySelector("input.fragno-input") ||
    fragnoInput?.querySelector("input");
  return { field, fragnoInput, value: nativeInput?.value?.trim() || "" };
}

function setError(fragnoInput, message) {
  if (!fragnoInput) return;
  fragnoInput.setAttribute("error", "");
  fragnoInput.setAttribute("error-message", message);
}

function clearError(fragnoInput) {
  if (!fragnoInput) return;
  fragnoInput.removeAttribute("error");
  fragnoInput.removeAttribute("error-message");
}

function clearAllErrors(form) {
  form.querySelectorAll("fragno-input[error]").forEach((fi) => clearError(fi));
}

function validateEmail(form) {
  const { fragnoInput, value } = getFragnoInput(form, "email");
  if (!value) {
    setError(fragnoInput, "This field is required.");
    return false;
  }
  if (!EMAIL_REGEX.test(value)) {
    setError(fragnoInput, "Please enter a valid email address.");
    return false;
  }
  return true;
}

function syncHiddenInputs(form) {
  const { value: emailValue } = getFragnoInput(form, "email");
  const { value: confirmValue } = getFragnoInput(form, "confirmation");
  const hiddenEmail = form.querySelector(".my-cash-paypal-form__hidden-email");
  const hiddenConfirmation = form.querySelector(
    ".my-cash-paypal-form__hidden-confirmation",
  );
  if (hiddenEmail) hiddenEmail.value = emailValue;
  if (hiddenConfirmation) hiddenConfirmation.value = confirmValue;
}

function validateConfirmation(form) {
  const { fragnoInput, value } = getFragnoInput(form, "confirmation");
  const { value: emailValue } = getFragnoInput(form, "email");
  if (!value) {
    setError(fragnoInput, "This field is required.");
    return false;
  }
  if (value !== emailValue) {
    setError(fragnoInput, "Email addresses do not match.");
    return false;
  }
  return true;
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initPaypalForm);
} else {
  initPaypalForm();
}
